import QueryKey from '@/enums/QueryKey';
import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useTaskTemplateData() {
    const { data: taskTemplates, isPending: isTaskTemplatesPending } = useQuery({
        queryKey: [QueryKey.DASHBOARD_TASKS_TEMPLATES],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.dashboard.tasks.templates.get'));
            return data;
        },
        placeholderData: [],
    });

    return {
        taskTemplates,
        isTaskTemplatesPending,
    };
}
